<!-- Path: libs/core/shell/src/lib/layout/public/hero/hero-card/hero-card.component.html -->
<article
  class="hero-card"
  [class.hero-card--clickable]="clickable()"
  [attr.tabindex]="clickable() ? 0 : null"
  [attr.role]="clickable() ? 'button' : null"
  (click)="onCardClick()"
  (keydown)="onCardKeydown($event)"
>
  <!-- Media: imagem + badge sobreposto -->
  <div class="hero-card__media">
    @if (badge()) {
      <span class="hero-card__badge">{{ badge() }}</span>
    }

    @if (hasImage()) {
      <img
        class="hero-card__image"
        [src]="imageUrl()!"
        [alt]="resolvedImageAlt()"
        loading="lazy"
      />
    } @else {
      <div class="hero-card__placeholder" aria-hidden="true">
        <span class="hero-card__placeholder-glow"></span>
      </div>
    }
  </div>

  <!-- Content: títutlo, descrição, preço, CTA -->
  <div class="hero-card__content">
    <div class="hero-card__copy">
      <h3 class="hero-card__title">{{ title() }}</h3>

      @if (description()) {
        <p class="hero-card__description">{{ description() }}</p>
      }
    </div>

    <div class="hero-card__footer">
      @if (showPrice()) {
        <div class="hero-card__pricing">
          <strong class="hero-card__price-current">
            {{ price()! | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
          </strong>

          @if (showComparePrice()) {
            <span class="hero-card__price-old">
              {{ compareAtPrice()! | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
            </span>
          }
        </div>
      }

      <button
        class="hero-card__cta"
        type="button"
        (click)="onActionClick($event)"
      >
        {{ ctaLabel() }}
      </button>
    </div>
  </div>
</article>
